import React from "react";
import PropTypes from "prop-types";
import MessageContainer from "../MessageContainer";
import { ReactComponent as TrophySvg } from "../../../../assets/chat/trophy.svg";
import { numberToOrdinal } from "../../../../helpers/common.helper";

const _prefix = "chat-tendering__work-approved";

const WorkApproved = ({ tenderingId, submission }) => {
  let submissionName = `${numberToOrdinal(submission.no + 1)} payment`;

  if (submission.final) {
    submissionName = "Final payment";
  }

  return (
    <MessageContainer alignment={"center"}>
      <div className={_prefix}>
        <TrophySvg width={24} />
        <div className={`${_prefix}__desc`}>
          <span style={{ fontWeight: 500, color: "#013565" }}>
            {submissionName} approved
          </span>
          <span>
            Please wait patiently for the owner to proceed with the payment.
            Thank you for your efforts
          </span>
        </div>
      </div>
    </MessageContainer>
  );
};

WorkApproved.propTypes = {};

export default WorkApproved;
